import {
    GET_BILL_LOADING,
    GET_BILL_SUCCESS,
    GET_BILL_FAILURE,
    GET_BILL_RESET
} from '../../actions/types';

const INITIAL_STATE = {
    bill: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};

const getBillReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_BILL_LOADING:
            return {
                ...state,
                bill: {
                    ...state.bill,
                    get: {
                        ...state.bill.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.bill.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_BILL_SUCCESS:
            return {
                ...state,
                bill: {
                    ...state.bill,
                    get: {
                        ...state.bill.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.bill.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_BILL_FAILURE:
            return {
                ...state,
                bill: {
                    ...state.bill,
                    get: {
                        ...state.bill.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.bill.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case GET_BILL_RESET:
            return {
                ...state,
                bill: {
                    ...state.bill.get,
                    post: {
                        ...INITIAL_STATE.bill.get,
                        reset: true,
                    },
                },
            }
    }
    return state;
};

export default getBillReducers;